<template>
  <el-card>
    <el-row class="template-task__title"> 模板任务 </el-row>
    <!-- 搜索 -->
    <el-row class="template-task__search">
      <span>任务类型</span>
      <el-select v-model="search.taskType" style="width: 150px" filterable clearable placeholder="请选择">
        <el-option v-for="(item, index) in (typeList || [])" :key="index" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <span>任务名称</span>
      <el-select v-model="search.taskName" style="width: 150px" filterable clearable allow-create placeholder="请选择">
        <el-option v-for="(item, index) in (desclist || [])" :key="index" :label="item.desc" :value="item.name"
          @click.native="change(item)">
        </el-option>
      </el-select>
      <span>展示名称</span>
      <el-input v-model="search.showName" placeholder="请输入内容" style="width: 200px"></el-input>
      <span>任务模板</span>
      <el-select v-model="search.taskTemplate" clearable filterable placeholder="请选择">
        <el-option v-for="(item, index) in (taskTemplateTypes || [])" :key="index" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
    </el-row>
    <el-row class="template-task__search">
      <span>渠道</span>
      <el-select v-model="search.channel" clearable filterable placeholder="请选择">
        <el-option v-for="item in (channelList || [])" :key="item.channelId" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <span>国家</span>
      <el-select v-model="search.countryCode" style="width: 150px" clearable filterable placeholder="请选择">
        <el-option v-for="item in (countryList || [])" :key="item.countryCode" :label="item.country" :value="item.countryCode">
        </el-option>
      </el-select>
      <span>状态</span>
      <el-select v-model="search.valid" style="width: 150px" clearable filterable placeholder="请选择">
        <el-option label="全部" :value="null"></el-option>
        <el-option label="上线" :value="1"></el-option>
        <el-option label="下线" :value="0"></el-option>
      </el-select>
      <el-button style="margin-left: 10px" type="success" @click="getAllTemplate(0)">搜索</el-button>
      <el-button style="margin-left: 10px" type="success" @click="dailogShow = true">添加</el-button>
    </el-row>
    <el-row>
      <el-button type="info" @click="isReset = true">重置</el-button>
    </el-row>
    <el-dialog :visible.sync="isReset" width="70%" title="模板任务配置">
      <el-row>
        <span>任务名称</span>
        <el-select v-model="resetData.taskName" style="width: 150px" filterable allow-create clearable
          placeholder="请选择">
          <el-option v-for="(item, index) in desclist" :key="index" :label="item.desc" :value="item.name">
            <!-- @click.native="change(item)" -->
          </el-option>
        </el-select></el-row>
      <el-row>
        <span>用户uid</span>
        <el-input v-model="resetData.rid"></el-input>
      </el-row>
      <el-row>
        <el-button @click="reset">确认</el-button>
      </el-row>
    </el-dialog>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="tableList" :key="news">
        <el-table-column prop="id" label="id" align="center"> </el-table-column>
        <el-table-column prop="orderIndex" label="优先级" sortable align="center">
        </el-table-column>
        <el-table-column prop="taskType" label="任务类型" align="center">
          <template slot-scope="scope"> 
            {{
              typeList.find((item) => item.value == scope.row.taskType)?.name ||
              ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="taskName" label="任务名称" align="center">
          <template slot-scope="scope">
            {{
              desclist.find((item) => item.name == scope.row.taskName)
                ? desclist.find((item) => item.name == scope.row.taskName)
                  .desc || ''
                : scope.row.taskName || ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="showName" label="展示名称" align="center">
          <template slot-scope="scope">
            {{
              scope.row.showName ? (() => {
                try {
                  let showNameData = scope.row.showName
                  // 如果是字符串，尝试解析 JSON
                  if (typeof showNameData === 'string') {
                    showNameData = JSON.parse(showNameData)
                  }
                  // 如果是对象，直接获取 en 属性
                  if (typeof showNameData === 'object' && showNameData !== null) {
                    return showNameData.en || ''
                  }
                  return ''
                } catch (e) {
                  return ''
                }
              })() : ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="userSign" label="用户标签" align="center">
        </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
        </el-table-column>
        <el-table-column prop="countryCode" label="国家" align="center">
        </el-table-column>
        <el-table-column prop="taskTemplate" label="任务模板" align="center">
          <template slot-scope="scope">
            {{
              taskTemplateTypes.find(
                (item) => item.value == scope.row.taskTemplate
              )?.name || ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column prop="mtime" label="修改时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.valid === 0 ? '下线' : '上线' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="380">
          <template slot-scope="scope">
            <el-button type="primary" @click="copyOrUpdate(scope.row, 1)">编辑</el-button>
            <el-button type="success" @click="copyOrUpdate(scope.row, 2)">复制</el-button>
            <el-button type="info" @click="deleteTemplate(scope.row.id)">删除</el-button>
            <el-button :type="scope.row.valid === 1 ? 'danger' : 'warning'" @click="changeValid(scope.row)">{{
              scope.row.valid === 1 ? '下线' : '上线' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination background layout="prev, pager, next" :total="totalPage" :page-size="pageSize"
        :current-page.sync="currentPage" @current-change="guaranteedHandleCurrentChange">
      </el-pagination>
    </el-row>
    <!-- 弹出框 -->
    <el-dialog @before-close="resetForm" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="dailogShow" width="70%" title="模板任务配置">
      <el-form ref="Form" :model="templateData" label-width="120px">
        <el-form-item label="任务类型">
          <el-select v-model="templateData.taskType" style="width: 400px" filterable clearable allow-create
            :disabled="isUpdate" placeholder="请选择" @change="triggerName(templateData.taskType)">
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务名称">
          <el-select v-if="templateData.taskType <= 0" v-model="templateData.taskName" style="width: 400px" filterable
            clearable allow-create :disabled="isUpdate" placeholder="请选择">
            <el-option v-for="(item, index) in desclist" :key="index" :label="item.desc" :value="item.name"
              @click.native="change(item)">
            </el-option>
          </el-select>
          <el-input v-else style="width: 400px" :disabled="isUpdate" v-model="templateData.taskName"
            placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="展示名称">
          <el-button type="primary" @click="
            () => {
              open(templateData.showName, 0)
              isShowName = true
            }
          ">展示名称列表</el-button>
        </el-form-item>
        <el-form-item label="渠道">
          <el-checkbox v-model="isChannel" style="margin-right: 10px">排除渠道</el-checkbox>
          <el-select v-model="templateData.channel" style="width: 400px" filterable multiple collapse-tags clearable
            placeholder="请选择">
            <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国家" label-width="120px">
          <el-checkbox v-model="isCountry" style="margin-right: 10px">排除国家</el-checkbox>
          <el-select v-model="templateData.countryCode" filterable multiple collapse-tags clearable placeholder="请选择"
            style="width: 400px">
            <el-option v-for="item in countryList" :key="item.countryCode" :label="item.country"
              :value="item.countryCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户标签">
          <!-- <el-checkbox v-model="isUserSign" style="margin-right: 10px">排除标签</el-checkbox> -->
          <el-select v-model="templateData.userSign" multiple filterable clearable placeholder="请选择" style="width: 400px">
            <el-option v-for="item in userSignList" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
          <el-form-item label="条件选择">
            <el-radio-group v-model="templateData.signChooseType">
              <el-radio :label="1">同时满足</el-radio>
              <el-radio :label="2">满足其中一个即可</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form-item>
        <el-form-item label="任务模版">
          <el-select v-model="templateData.taskTemplate" clearable filterable placeholder="请选择"
            @change="() => (descs = [])">
            <el-option v-for="(item, index) in taskTemplateTypes" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生效时间(北京时区)">
          <el-date-picker v-model="times" type="datetimerange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="timestamp" @change="changes">
          </el-date-picker>
          <span style="margin-left: 20px; margin-right: 10px;">剩余展示时间(小时):</span>
          <el-input 
            v-model.number="templateData.countDown" 
            style="width: 200px" 
            placeholder="请输入剩余展示时间"
            type="number"
            :min="1"
            @blur="validateCountDown">
          </el-input>
          <span v-if="countDownError" style="color: red; margin-left: 10px; font-size: 12px;">{{ countDownError }}</span>
        </el-form-item>
        <el-form-item label="优先级">
          <el-input style="width: 100px" v-model="templateData.orderIndex" laceholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="任务类型配置">
          <el-checkbox v-model="isTimeLimitTask" @change="onTimeLimitTaskChange">限时任务</el-checkbox>
          <span style="margin-left: 20px;"></span>
          <el-checkbox v-model="isSpecialTask" @change="onSpecialTaskChange">专属任务</el-checkbox>
        </el-form-item>
        <!-- 多节点任务 -->
        <template v-if="templateData.taskTemplate === 1">
          <el-row v-if="templateData.taskType > 0">
            <el-form-item label="奖励模式">
              <el-select v-model="multiNode.rewardMode" clearable filterable placeholder="请选择">
                <el-option v-for="(item, index) in awardMode" :key="index" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="描述">
              <el-button type="primary" @click="
                () => {
                  open(multiNode.desc, 1)
                  status = 0
                }
              ">描述列表</el-button>
            </el-form-item>
          </el-row>
          <el-row>
            钱包描述：
            <el-input v-model="multiNode.goldDesc" style="width: 200px; margin-right: 10px"
              placeholder="请输入"></el-input>
            <el-button @click="openAward(multiNode.award)" type="primary">奖励列表</el-button>
          </el-row>
          <el-row style="padding: 25px; border: 2px dotted #000">
            <el-row style="
                border: 2px dotted #000;
                padding: 10px;
                margin-bottom: 30px;
              " v-for="(item, index) in multiNode.item" :key="index">
              <el-row>
                任务节点：
                <el-select v-if="templateData.taskType <= 0" v-model="item.nodeId" filterable clearable allow-create
                  placeholder="请选择" style="width: 200px; margin: 0 5px">
                  <el-option v-for="(items, index) in nodeList" :key="index" :label="items.desc" :value="items.name">
                    <template #default>{{
                      items.desc ? items.desc : items.value
                    }}</template>
                  </el-option>
                </el-select>
                <el-input v-else style="width: 400px" v-model="item.nodeId" placeholder="请输入"></el-input>
                <span style="color: #ff6b6b; font-size: 12px; margin-left: 10px;">⚠️ 任务节点不要轻易修改，修改后会导致用户该节点数据重置</span>
              </el-row>
              <el-row>
                任务描述：
                <el-button type="primary" @click="
                  () => {
                    open(item.desc, 1)
                    indexs = index
                    status = 1
                  }
                ">描述列表</el-button>
                <template v-if="templateData.taskType <= 0">
                  跳转页面:
                  <el-select v-model="item.jumpPage" filterable clearable placeholder="请选择"
                    style="width: 200px; margin: 0 5px">
                    <el-option v-for="item in jumpPages" :key="item.value" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
                <template v-else>
                  跳转页面:
                  <el-cascader v-model="item.jumpPage" clearable :options="formatterJumpData(jumpPages, templateData.taskType)"
                    :props="{ emitPath: false }"></el-cascader>
                </template>
              </el-row>
              <el-row>
                占比：
                <el-input v-model="item.proportion" placeholder="请输入" type="number"
                  style="width: 100px; margin-right: 5px"></el-input>
                总数量：
                <el-input v-model="item.totalCount" placeholder="请输入" type="number"
                  style="width: 100px; margin-right: 5px"></el-input>
                <template v-if="templateData.taskType > 0">
                  条件1：
                  <el-input v-model="item.condition1" placeholder="请输入" type="number"
                    style="width: 100px; margin-right: 5px" :autosize="true"></el-input>
                  单位：
                  <el-select v-model="item.condition1FormatType" placeholder="请选择" style="width: 100px; margin-right: 5px">
                    <el-option label="默认（之前逻辑）" :value="0"></el-option>
                    <el-option label="秒" :value="1"></el-option>
                    <el-option label="分钟" :value="2"></el-option>
                  </el-select>
                </template>
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                周期类型:
                <el-select v-model="item.periodType" filterable clearable placeholder="请选择"
                  style="width: 200px; margin: 0 5px">
                  <el-option v-for="item in PeriodType" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
                <!-- 是否重复:
                <el-switch
                  v-model="item.repeat"
                  active-text="重复"
                  inactive-text="不重复"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch> -->
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                触发类型：
                <el-select v-model="item.triggerName" filterable clearable allow-create placeholder="请选择"
                  style="width: 200px; margin: 0 5px" @change="
                    (value) => {
                      tips(value, index)
                      $forceUpdate()
                    }
                  ">
                  <el-option v-for="(items, index) in triggerList" :key="index" :label="items.name"
                    :value="items.value">
                  </el-option>
                </el-select>
              </el-row>
              <el-row v-if="descs[index] && templateData.taskType > 0" style="color: #ffc107">{{ descs[index]
              }}</el-row>
              <el-row v-if="templateData.taskType > 0">
                时间参数：
                <el-input v-model="item.timeParam" style="width: 200px" placeholder="请输入"></el-input>
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                参数1：
                <el-input v-model="item.param1" style="width: 200px" placeholder="请输入"></el-input>
              </el-row>
              <el-button @click="multiNode.item.splice(index, 1)" type="danger">删除</el-button>
            </el-row>
            <div style="
                height: 50px;
                width: 50px;
                line-height: 50px;
                font-size: 20px;
                border: 1px solid #ccc;
                text-align: center;
                cursor: pointer;
                border-radius: 50%;
              " @click="multiNode.item.push({ desc: '', jumpPage: 0 })">
              +
            </div>
          </el-row>
        </template>
        <!-- 周期任务 -->
        <template v-else-if="templateData.taskTemplate === 2">
          <el-row style="padding: 25px; border: 2px dotted #000">
            <el-row style="
                border: 2px dotted #000;
                padding: 10px;
                margin-bottom: 20px;
              " v-for="(item, index) in durationNode.item" :key="index">
              <el-row>
                任务节点:
                <el-select v-if="templateData.taskType <= 0" v-model="item.nodeId" filterable clearable allow-create
                  placeholder="请选择" style="width: 200px; margin: 0 5px">
                  <el-option v-for="(items, index) in nodeList" :key="index" :label="items.desc" :value="items.name">
                    <template #default>{{
                      items.desc ? items.desc : items.value
                    }}</template>
                  </el-option>
                </el-select>
                <el-input v-else style="width: 400px" v-model="item.nodeId" placeholder="请输入"></el-input>
                <span style="color: #ff6b6b; font-size: 12px; margin-left: 10px;">⚠️ 任务节点不要轻易修改，修改后会导致用户该节点数据重置</span>
              </el-row>
              <el-row>
                天数：
                <el-input v-model="item.day" placeholder="输入天数" type="number" style="width: 100px; margin-right: 5px"
                  :autosize="true"></el-input>
                任务描述：
                <el-button type="primary" @click="
                  () => {
                    open(item.desc, 1)
                    indexs = index
                    status = 2
                  }
                ">描述列表</el-button>
              </el-row>
              <el-row>
                总数量：
                <el-input v-model="item.totalCount" placeholder="输入总数" type="number"
                  style="width: 100px; margin-right: 5px" :autosize="true"></el-input>
                奖励比例:
                <el-input v-model="item.rate" placeholder="输入总数" type="number" style="width: 100px; margin-right: 5px"
                  :autosize="true"></el-input>
                <template v-if="templateData.taskType > 0">
                  条件1：
                  <el-input v-model="item.condition1" placeholder="请输入" type="number"
                    style="width: 100px; margin-right: 5px" :autosize="true"></el-input>
                  单位：
                  <el-select v-model="item.condition1FormatType" placeholder="请选择" style="width: 100px; margin-right: 5px">
                    <el-option label="默认（之前逻辑）" :value="0"></el-option>
                    <el-option label="秒" :value="1"></el-option>
                    <el-option label="分钟" :value="2"></el-option>
                  </el-select>
                </template>
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                周期类型:
                <el-select v-model="item.periodType" filterable clearable placeholder="请选择"
                  style="width: 200px; margin: 0 5px">
                  <el-option v-for="item in PeriodType" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
                <!-- 是否重复:
                <el-switch
                  v-model="item.repeat"
                  active-text="重复"
                  inactive-text="不重复"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch> -->
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                触发类型：
                <el-select v-model="item.triggerName" filterable clearable allow-create placeholder="请选择"
                  style="width: 200px; margin: 0 5px" @change="
                    (value) => {
                      tips(value, index)
                      $forceUpdate()
                    }
                  ">
                  <el-option v-for="(items, index) in triggerList" :key="index" :label="items.name"
                    :value="items.value">
                  </el-option>
                </el-select>
              </el-row>
              <el-row v-if="descs[index] && templateData.taskType > 0" style="color: #ffc107">{{ descs[index]
              }}</el-row>
              <el-row v-if="templateData.taskType > 0">
                时间参数：
                <el-input v-model="item.timeParam" style="width: 200px" placeholder="请输入"></el-input>
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                参数1：
                <el-input v-model="item.param1" style="width: 200px" placeholder="请输入"></el-input>
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                奖励模式:
                <el-select v-model="item.rewardMode" clearable filterable placeholder="请选择">
                  <el-option v-for="(item, index) in awardMode" :key="index" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </el-row>
              <el-row>
                钱包描述：
                <el-input v-model="item.goldDesc" style="width: 200px; margin-right: 10px" placeholder="请输入"></el-input>
                <el-button @click="openAward(item.award)" type="primary">奖励列表</el-button>
              </el-row>
              <el-button @click="durationNode.item.splice(index, 1)" type="danger">删除</el-button>
            </el-row>
            <div style="
                height: 50px;
                width: 50px;
                line-height: 50px;
                font-size: 20px;
                border: 1px solid #ccc;
                text-align: center;
                cursor: pointer;
                border-radius: 50%;
              " @click="
                durationNode.item.push({
                  day: 1,
                  desc: '',
                  totalCount: 0,
                  completeCount: 0,
                  award: [],
                })
                ">
              +
            </div>
          </el-row>
        </template>
        <!-- 组任务 -->
        <template v-else-if="templateData.taskTemplate === 3">
          <el-row style="padding: 25px; border: 2px dotted #000">
            <el-row style="
                border: 2px dotted #000;
                padding: 10px;
                margin-bottom: 20px;
              " v-for="(item, index) in groupTask.item" :key="index">
              <el-row>
                任务节点:
                <el-select v-if="templateData.taskType <= 0" v-model="item.nodeId" filterable clearable allow-create
                  placeholder="请选择" style="width: 200px; margin: 0 5px">
                  <el-option v-for="(items, index) in nodeList" :key="index" :label="items.desc" :value="items.name">
                    <template #default>{{
                      items.desc ? items.desc : items.value
                    }}</template>
                  </el-option>
                </el-select>
                <el-input v-else style="width: 400px" v-model="item.nodeId" placeholder="请输入"></el-input>
                <span style="color: #ff6b6b; font-size: 12px; margin-left: 10px;">⚠️ 任务节点不要轻易修改，修改后会导致用户该节点数据重置</span>
              </el-row>
              <el-row>
                任务描述：
                <el-button type="primary" @click="
                  () => {
                    open(item.desc, 1)
                    indexs = index
                    status = 3
                  }
                ">描述列表</el-button>
                <template v-if="templateData.taskType <= 0">
                  跳转页面:
                  <el-select v-model="item.jumpPage" filterable clearable placeholder="请选择"
                    style="width: 200px; margin: 0 5px">
                    <el-option v-for="item in jumpPages" :key="item.value" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
                <template v-else>
                  跳转页面:
                  <el-cascader v-model="item.jumpPage" clearable :options="formatterJumpData(jumpPages, templateData.taskType)"
                    :props="{ emitPath: false }"></el-cascader>
                </template>
              </el-row>
              <el-row>
                总数量：
                <el-input v-model="item.totalCount" placeholder="输入总数" type="number"
                  style="width: 100px; margin-right: 5px" :autosize="true"></el-input>
                条件1：
                <el-input v-model="item.condition1" placeholder="请输入" type="number"
                  style="width: 100px; margin-right: 5px" :autosize="true"></el-input>
                单位：
                <el-select v-model="item.condition1FormatType" placeholder="请选择" style="width: 100px; margin-right: 5px">
                  <el-option label="默认（之前逻辑）" :value="0"></el-option>
                  <el-option label="秒" :value="1"></el-option>
                  <el-option label="分钟" :value="2"></el-option>
                </el-select>
              </el-row>
              <el-row>
                图标：
                <el-select v-model="item.isIcon" placeholder="请选择" style="margin-right: 5px">
                  <el-option label="上传图片" :value="0"> </el-option>
                  <el-option label="填写链接" :value="1"> </el-option>
                </el-select>
                <UploadSingleImg v-model="item.icon" :on-upload="uploadFile" v-if="item.isIcon === 0" />
                <el-input v-else v-model="item.icon" placeholder="请填写链接" style="width: 300px"></el-input>
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                周期类型:
                <el-select v-model="item.periodType" filterable clearable placeholder="请选择"
                  style="width: 200px; margin: 0 5px">
                  <el-option v-for="item in PeriodType" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
                <!-- 是否重复:
                <el-switch
                  v-model="item.repeat"
                  active-text="重复"
                  inactive-text="不重复"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch> -->
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                触发类型：
                <el-select v-model="item.triggerName" filterable clearable allow-create placeholder="请选择"
                  style="width: 200px; margin: 0 5px" @change="
                    (value) => {
                      tips(value, index)
                      $forceUpdate()
                    }
                  ">
                  <el-option v-for="(items, index) in triggerList" :key="index" :label="items.name"
                    :value="items.value">
                  </el-option>
                </el-select>
              </el-row>
              <el-row v-if="descs[index] && templateData.taskType > 0" style="color: #ffc107">{{ descs[index]
              }}</el-row>
              <el-row v-if="templateData.taskType > 0">
                时间参数：
                <el-input v-model="item.timeParam" style="width: 200px" placeholder="请输入"></el-input>
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                参数1：
                <el-input v-model="item.param1" style="width: 200px" placeholder="请输入"></el-input>
              </el-row>
              <el-row v-if="templateData.taskType > 0">
                奖励模式:
                <el-select v-model="item.rewardMode" clearable filterable placeholder="请选择">
                  <el-option v-for="(item, index) in awardMode" :key="index" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </el-row>
              <el-row>
                钱包描述：
                <el-input v-model="item.goldDesc" style="width: 200px; margin-right: 10px" placeholder="请输入"></el-input>
                <el-button @click="openAward(item.award)" type="primary">奖励列表</el-button>
              </el-row>
              <el-button @click="groupTask.item.splice(index, 1)" type="danger">删除</el-button>
            </el-row>
            <div style="
                height: 50px;
                width: 50px;
                line-height: 50px;
                font-size: 20px;
                border: 1px solid #ccc;
                text-align: center;
                cursor: pointer;
                border-radius: 50%;
              " @click="
                groupTask.item.push({
                  desc: '',
                  icon: '',
                  totalCount: 0,
                  completeCount: 0,
                  taskStatus: 0,
                  award: [],
                  jumpPage: 0,
                })
                ">
              +
            </div>
          </el-row>
        </template>
        <el-form-item>
          <el-button @click="resetForm" type="info">取消</el-button>
          <el-button type="primary" @click="submit">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 奖励弹窗 -->
    <el-dialog :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="isAward"
      title="礼物配置">
      <div class="add">
        <el-row>
          <el-button type="success" @click="
            () => {
              rewardDrwer = true
              getAllAwards()
            }
          ">
            创建
          </el-button>
        </el-row>
        <el-row>
          <el-table height="60vh" :key="itemKey" :data="templateAward" style="width: 100%" border>
            <el-table-column prop="awardType" label="类型" align="center">
            </el-table-column>
            <el-table-column prop="awardName" label="奖品名字" align="center">
            </el-table-column>
            <el-table-column prop="awardNum" label="奖品数量" align="center">
            </el-table-column>
            <el-table-column prop="awardIcon" label="奖励图标" align="center">
              <template slot-scope="scope">
                <el-image v-if="scope.row.awardIcon !== ''" style="width: 100px; height: 100px"
                  :src="scope.row.awardIcon" :preview-src-list="[scope.row.awardIcon]">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="180px">
              <template slot-scope="scope">
                <el-button type="warning" @click="upDateAward(scope.row, scope.$index)" size="mini">修改</el-button>
                <el-button type="danger" @click="deleteAward(scope.row, scope.$index)" size="mini">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
      <el-row style="margin-top: 10px">
        <el-button @click="cancel(0)" type="primary">取消</el-button>
        <el-button @click="submitAward" type="primary">确认</el-button>
      </el-row>
    </el-dialog>

    <el-dialog :visible.sync="rewardDrwer" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false" width="800px">
      <div class="add">
        <el-row>
          <el-row>
            <el-button type="info" @click="toAward">奖励配置</el-button>
          </el-row>
          <el-col class="el-cols">
            <el-table :data="awardbaselist" @row-click="handle" :header-cell-style="{ background: '#F8F8F9' }"
              style="width: 100%">
              <el-table-column label="选择" align="center" width="65">
                <template scope="scope">
                  <el-radio :label="scope.row.id" v-model="awardId">{{
                    ''
                  }}</el-radio>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="name" label="奖品名"></el-table-column>
              <el-table-column align="center" prop="icon" label="图标">
                <template scope="scope">
                  <el-image style="width: 50px; height: 50px" :src="scope.row.icon"
                    :preview-src-list="[scope.row.icon]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="bigIcon" label="大图标">
                <template scope="scope">
                  <el-image style="width: 50px; height: 50px" :src="scope.row.bigIcon"
                    :preview-src-list="[scope.row.bigIcon]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="unitPrice" label="单价"></el-table-column>
              <el-table-column align="center" prop="awardDesc" label="描述"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>奖品数量:</span>
            <el-input-number v-model="awardNum" label="请输入数量"></el-input-number>
          </el-col>
        </el-row>
      </div>
      <div class="buttom_">
        <el-button @click="
          () => {
            rewardDrwer = false
            awardNum = 0
            awardId = 0
          }
        " type="primary">取消</el-button>
        <el-button type="primary" @click="operate">确认</el-button>
      </div>
    </el-dialog>

    <!-- 展示名称多语言配置 -->
    <el-dialog :visible.sync="isShowName" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false" width="800px">
      <el-row v-for="(item, index) in showNames" :key="index">
        <span>语言</span>
        <el-select style="margin: 0 5px; width: 150px" v-model="item.lang" filterable placeholder="请选择">
          <el-option v-for="item in langList" :key="item.langCode" :label="item.language"
            :value="item.langCode"></el-option>
        </el-select>
        <span>展示名称</span>
        <el-input v-model="item.desc" placeholder="输入描述" type="textarea" style="width: 250px; margin: 5px"
          :autosize="true"></el-input>
        <el-button type="danger" @click="showNames.splice(index, 1)">删除</el-button>
      </el-row>
      <el-row>
        <el-button type="success" @click="showNames.push({ lang: '', desc: '' })">+</el-button>
      </el-row>
      <el-row>
        <el-button @click="cancel(1)">取消</el-button>
        <el-button @click="isSuccess(0)">确认</el-button>
      </el-row>
    </el-dialog>
    <!-- 描述多语言配置 -->
    <el-dialog :visible.sync="isDesc" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      width="800px">
      <el-row v-for="(item, index) in langDescs" :key="index">
        <span>语言</span>
        <el-select style="margin: 0 5px; width: 150px" v-model="item.lang" filterable placeholder="请选择">
          <el-option v-for="item in langList" :key="item.langCode" :label="item.language"
            :value="item.langCode"></el-option>
        </el-select>
        <span>描述</span>
        <el-input v-model="item.desc" placeholder="输入描述" type="textarea" style="width: 250px; margin: 5px"
          :autosize="true"></el-input>
        <el-button type="danger" @click="langDescs.splice(index, 1)">删除</el-button>
      </el-row>
      <el-row>
        <el-button type="success" @click="langDescs.push({ lang: '', desc: '' })">+</el-button>
      </el-row>
      <el-row>
        <el-button @click="cancel(2)">取消</el-button>
        <el-button @click="
          () => {
            isSuccess(1)
            isShowName = false
          }
        ">确认</el-button>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
import { allRewardList } from '@/utils/normalApi.js'
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg'
import { trigger } from 'video.js'
export default {
  components: {
    UploadSingleImg,
  },
  data() {
    return {
      status: 0,
      indexs: 0,
      awardbaselist: [],
      rewardDrwer: false,
      awardNum: 0,
      awardId: 0,
      shortId: null,
      isChange: false,
      itemKey: 0,
      isChannel: false,
      isCountry: false,
      isUserSign: false,
      // 是否编辑
      isUpdate: false,
      // 弹出框是否显示
      dailogShow: false,
      // 奖励列表显示
      isAward: false,
      // 描述显示
      isDesc: false,
      //展示名称显示
      isShowName: false,
      isReset: false,
      // 每页显示数量
      pageSize: 30,
      // 总页数
      totalPage: 10,
      // 语言列表
      langList: [],
      // 当前页数
      currentPage: 0,
      short: [],
      // 描述列表
      langDescs: [{ lang: null, desc: '' }],
      // 展示名称列表
      showNames: [{ lang: null, desc: '' }],
      // 国家列表
      countryList: [],
      // 渠道列表
      channelList: [],
      // 任务列表
      desclist: [],
      // 节点列表
      nodeList: [],
      // 表单数据
      tableList: [],
      // 奖励模式
      awardMode: [
        {
          name: '手动领取',
          value: 0,
        },
        {
          name: '自动发奖',
          value: 1,
        },
      ],
      desc: '',
      // 跳转页面
      jumpPages: [
        // {
        //   name: '无',
        //   value: 0,
        // },
        // {
        //   name: '首页',
        //   value: 1,
        // },
        // {
        //   name: '上传照片',
        //   value: 2,
        // },
        // {
        //   name: '上传视频',
        //   value: 3,
        // },
        // {
        //   name: '资料编辑页',
        //   value: 4,
        // },
        // {
        //   name: '上传照片',
        //   value: 5,
        // },
        // {
        //   name: '绑定手机号码',
        //   value: 6,
        // },
        // {
        //   name: '跳到美颜设置页',
        //   value: 7,
        // },
        // {
        //   name: '跳到一个随机的语聊房',
        //   value: 8,
        // },
        // {
        //   name: '跳到Viewers页面',
        //   value: 9,
        // },
        // {
        //   name: '培训视频页面',
        //   value: 10,
        // },
      ],
      // 模板类型
      taskTemplateTypes: [
        {
          name: '无',
          value: 0,
        },
        {
          name: '多节点任务',
          value: 1,
        },
        {
          name: '周期任务',
          value: 2,
        },
        {
          name: '组任务',
          value: 3,
        },
      ],
      // 任务类型
      typeList: [],
      triggerList: [],
      // 描述数组（用于显示触发类型的描述）
      descs: [],
      news: 0,
      // 重置
      resetData: {
        rid: null,
        taskName: null,
      },
      // 查询数据
      search: {
        taskType: null,
        taskName: null,
        showName: null,
        taskTemplate: null,
        channel: null,
        countryCode: null,
        valid: null,
      },
      times: null,
      // 模板配置数据
      templateData: {
        taskType: null,
        taskName: null,
        showName: null,
        channel: null,
        countryCode: null,
        signChooseType: 2,
        taskTemplate: null,
        userSign: null,
        taskJson: null,
        startTime: null,
        endTime: null,
        valid: 0,
        orderIndex: 0,
        countDown: null,
        timeLimitTask: 0,
        specialTask: 0,
      },
      countDownError: '',
      // 复选框绑定值
      isTimeLimitTask: false,
      isSpecialTask: false,
      PeriodType: [
        {
          name: '每日',
          value: 1,
        },
        {
          name: '每周',
          value: 2,
        },
        {
          name: '每月',
          value: 3,
        },
      ],
      // 奖励模板数据
      templateAward: [
        // {
        //   // 奖励类型
        //   awardType: null,
        //   // 奖励数量
        //   awardNum: null,
        //   // 奖励名字
        //   awardName: '',
        //   // 奖励物品图标
        //   awardIcon: '',
        //   // 奖品id
        //   dateId: null,
        // },
      ],
      templateAwardShort: [],
      userSignList: [],
      // 多节点任务数据
      multiNode: {
        item: [
          {
            desc: '',
            jumpPage: 0,
            proportion: 0,
            totalCount: 0,
            nodeId: '',
            periodType: null,
            triggerName: null,
            condition1: 0,
            condition1FormatType: 0,
            timeParam: '',
            param1: '',
          },
        ],
        desc: '',
        award: [],
        rewardMode: 0,
        goldDesc: '',
      },
      // 周期任务数据
      durationNode: {
        item: [
          {
            day: 1,
            nodeId: '',
            desc: '',
            totalCount: 0,
            rate: 0,
            periodType: null,
            award: [],
            triggerName: null,
            condition1: 0,
            condition1FormatType: 0,
            rewardMode: 0,
            goldDesc: '',
            timeParam: '',
            param1: '',
          },
        ],
      },
      // 组任务数据
      groupTask: {
        item: [
          {
            desc: '',
            icon: '',
            nodeId: '',
            totalCount: 0,
            award: [],
            jumpPage: 0,
            isIcon: 0,
            condition1: 0,
            condition1FormatType: 0,
            periodType: null,
            triggerName: null,
            rewardMode: 0,
            goldDesc: '',
            timeParam: '',
            param1: '',
          },
        ],
      },
    }
  },
  mounted() {
    this.getAllPullDown()
  },
  methods: {
    changes(value) {
      if (value && Array.isArray(value) && value.length >= 2) {
        this.templateData.startTime = value[0] / 1000
        this.templateData.endTime = value[1] / 1000
        // 重新校验倒计时
        if (this.templateData.countDown) {
          this.validateCountDown()
        }
      } else {
        // 如果值为空，清空时间
        this.templateData.startTime = null
        this.templateData.endTime = null
      }
    },
    // 校验倒计时时间
    validateCountDown() {
      this.countDownError = ''
      
      if (!this.templateData.countDown) {
        return
      }

      // 校验是否为正整数
      const countDown = Number(this.templateData.countDown)
      if (!Number.isInteger(countDown) || countDown <= 0) {
        this.countDownError = '必须为正整数'
        return
      }

      // 校验是否超过生效时间总时长
      if (this.templateData.startTime && this.templateData.endTime) {
        const totalHours = (this.templateData.endTime - this.templateData.startTime) / 3600
        if (countDown > totalHours) {
          this.countDownError = `不能超过生效时间总时长(${Math.floor(totalHours)}小时)`
          return
        }
      }
    },
    // 限时任务变化处理
    onTimeLimitTaskChange(value) {
      this.templateData.timeLimitTask = value ? 1 : 0
    },
    // 专属任务变化处理
    onSpecialTaskChange(value) {
      this.templateData.specialTask = value ? 1 : 0
    },
    // 判断任务类型是否为用户数据（6,7,8,9）
    isUserTaskType(taskType) {
      return taskType === 6 || taskType === 7 || taskType === 8 || taskType === 9
    },
    tips(value, index) {
      const desc =
        this.triggerList.find((item) => item.value == value)?.desc || ''
      this.descs[index] = desc
    },
    handle(row) {
      this.awardId = row.id
    },
    change(info) {
      this.getAlldesc(info.name, info.templateType)
      this.templateData.taskTemplate = info.templateType
    },
    // changeNode(info, nodeInfo) {
    //   console.log(info)
    //   console.log(nodeInfo)
    //   if (nodeInfo.desc) {
    //     info.desc = nodeInfo.desc
    //     console.log(1)
    //   }
    // },
    convertToLangDesc(obj) {
      if (typeof obj === 'object' && obj !== null) {
        const resp = []
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            resp.push({ lang: key, desc: obj[key] })
          }
        }
        return resp
      }
      return obj
    },
    convertFromLangDesc(obj) {
      if (typeof obj === 'object' && obj !== null) {
        const result = {}
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            const item = obj[key]
            if (item.lang && item.desc) {
              result[item.lang] = item.desc
            } else {
              result[key] = item
            }
          }
        }
        return result
      }
      return obj
    },
    // 格式化跳转页面数据
    formatterJumpData(data, taskType) {
      // 创建两个数组分别存放苹果和安卓组的数据
      const groupedData = [
        { label: '安卓-主播', children: [] },
        { label: '苹果-主播', children: [] },
        { label: 'tikko-主播', children: [] },
        { label: '苹果-用户', children: [] },
        { label: '安卓-用户', children: [] },
      ]

      // 遍历原始数据，按照 value 大小分类
      data.forEach((item) => {
        if (item.value >= 2000 && item.value < 3000) {
          // 如果 value 在 2000-2999 之间，属于 tikko 组
          groupedData[2].children.push({ label: item.name, value: item.value })
        } else if (item.value >= 3000 && item.value < 4000) {
          // 如果 value 在 3000-3999 之间，属于苹果用户组
          groupedData[3].children.push({ label: item.name, value: item.value })
        } else if (item.value >= 4000 && item.value < 5000) {
          // 如果 value 在 4000-4999 之间，属于安卓用户组
          groupedData[4].children.push({ label: item.name, value: item.value })
        } else if (item.value > 100) {
          // 如果 value 大于 100，属于苹果组
          groupedData[1].children.push({ label: item.name, value: item.value })
        } else {
          // 如果 value 小于等于 100，属于安卓组
          groupedData[0].children.push({ label: item.name, value: item.value })
        }
      })

      // 根据任务类型过滤返回的数据
      if (this.isUserTaskType(taskType)) {
        // 用户数据：只返回后2个分组（苹果-用户、安卓-用户）
        return groupedData.slice(3, 5)
      } else {
        // 主播数据：只返回前3个分组（安卓-主播、苹果-主播、tikko-主播）
        return groupedData.slice(0, 3)
      }
    },
    // 获取任务类型
    async getTaskType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.enums.TaskType',
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.typeList = res.data
      }
    },
    // 获取跳转页面
    async getJump() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.enums.JumpPage',
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.jumpPages = res.data
      }
    },
    async triggerName(taskType) {
      // 根据任务类型选择不同的 className
      // 如果没有传入 taskType 或 taskType 不是用户类型，默认使用主播数据
      const className = taskType && this.isUserTaskType(taskType)
        ? 'com.quhong.enums.UserTaskTriggerName'
        : 'com.quhong.enums.TaskTriggerName'
      
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: className,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.triggerList = res.data
      }
    },
    // 获取任务
    async getAlldesc(info = null, type = 0) {
      let data = {
        taskName: info,
      }

      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_template_desc,
        data,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        if (type === 0) {
          this.desclist = res.data.list
        } else {
          this.nodeList = res.data.list
        }
      }
    },
    //获取语言
    async getLang() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.langList,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.langList = res.data
      }
    },
    // 跳转奖励配置页面
    toAward() {
      this.rewardDrwer = false
      this.awardNum = 0
      this.awardId = 0
      this.cancel()
      this.resetForm()
      this.$router.push({
        path: '/config/reward',
        query: {
          active: '3',
        },
      })
    },
    //删除奖励
    deleteAward(id, index) {
      this.templateAward.splice(index, 1)
    },
    // 修改奖励
    upDateAward(info, index) {
      this.shortData = info
      this.awardNum = info.awardNum
      this.awardId = info.id
      this.shortId = index
      this.getAllAwards()
      this.rewardDrwer = true
    },
    // 获取礼物配置
    async getAllAwards() {
      // 获取奖励列表
      this.awardbaselist = await allRewardList(1099)
    },
    // 打开奖励列表
    openAward(info) {
      let data = []
      try {
        data = JSON.parse(JSON.stringify(info || []))
      } catch (e) {
        data = []
      }
      this.templateAwardShort = data
      this.isAward = true
      this.templateAward = info || []
    },
    // 确认礼物
    operate() {
      let data = {}
      try {
        const foundItem = this.awardbaselist.find((item) => item.id == this.awardId)
        if (foundItem) {
          data = JSON.parse(JSON.stringify(foundItem))
        }
      } catch (e) {
        console.error('Error in operate method:', e)
      }
      
      let cenData = {}
      cenData.awardNum = this.awardNum
      cenData.awardIcon = data.icon || ''
      cenData.awardName = data.name || ''
      cenData.dateId = data.dataId || null
      cenData.awardType = data.awardType || null
      if (this.shortId || this.shortId == 0) {
        this.templateAward[this.shortId] = cenData
        this.shortId = null
        this.itemKey++
      } else {
        this.templateAward.push(cenData)
      }
      this.awardNum = 0
      this.rewardDrwer = false
    },
    submitAward() {
      this.isAward = false
    },
    isSuccess(type = 0) {
      let data
      if (type === 0) {
        data = this.convertFromLangDesc(this.showNames)
        data = JSON.stringify(data)
        this.templateData.showName = data
        this.cancel(1)
      } else {
        data = this.convertFromLangDesc(this.langDescs)
        data = JSON.stringify(data)
        if (this.status === 0) {
          this.multiNode.desc = data
        } else if (this.status === 1) {
          this.multiNode.item[this.indexs].desc = data
        } else if (this.status === 2) {
          this.durationNode.item[this.indexs].desc = data
        } else if (this.status === 3) {
          this.groupTask.item[this.indexs].desc = data
        }
        this.cancel(2)
      }
    },
    open(info, type = 0) {
      console.log(info)
      let data = null
      
      // 如果 info 为空或未定义，直接返回空数组
      if (!info) {
        data = []
      } else if (typeof info === 'string') {
        // 如果是字符串，尝试解析 JSON
        try {
          const parsed = JSON.parse(info)
          data = this.convertToLangDesc(parsed)
        } catch (e) {
          // 如果解析失败，当作普通字符串处理
          data = [{ lang: 'en', desc: info }]
        }
      } else if (Array.isArray(info)) {
        // 如果已经是数组，直接使用（可能是之前已经转换过的数据）
        data = info
      } else if (typeof info === 'object') {
        // 如果已经是对象，转换为数组格式
        data = this.convertToLangDesc(info)
      } else {
        data = []
      }
      
      // 确保 data 是数组
      if (!Array.isArray(data)) {
        data = []
      }
      
      this.short = info
      if (type === 0) {
        this.showNames = data
        this.isShowName = true
      } else {
        this.langDescs = data
        this.isDesc = true
      }
    },
    // 取消礼物
    cancel(type = 0) {
      this.isChannel = false
      this.isCountry = false
      this.isUserSign = false
      if (type === 0) {
        this.templateAward = this.templateAwardShort
        this.templateAwardShort = []
        this.isAward = false
      } else if (type === 1) {
        this.showNames = []
        this.short = []
        this.isShowName = false
      } else if (type === 2) {
        this.langDescs = this.short || null
        this.short = []
        this.isDesc = false
      }
    },
    // 图片上传
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'room/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    //获取所有数据
    getAllPullDown() {
      this.getChannel()
      this.getCountryCode()
      this.getAllTemplate()
      this.getUserSigns()
      this.getAllAwards()
      this.getAlldesc()
      this.getLang()
      this.getTaskType()
      this.triggerName()
      this.getJump()
    },
    // 重置数据
    async reset() {
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_template_reset,
        data: this.resetData,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('重置成功')
        this.isReset = false
      }
    },
    //获取用户标签列表
    async getUserSigns() {
      let userSignData = {
        page: -1,
        pageSize: 1000,
        data: {
          signType: 'task',
        },
      }

      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_userSign_query,
        data: userSignData,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.userSignList = res.data.list
      }
    },
    // 格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    //获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    //获取国家选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = res.data.countryList
      }
    },
    //获取所有模板数据
    async getAllTemplate(page) {
      let pages = page || this.currentPage
      let info = {
        data: this.search,
        page: pages,
      }
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_template_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: info,
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.totalPage = res.data.total
        this.tableList = [...res.data.list]
        this.news++
      }
    },
    //修改当前页
    guaranteedHandleCurrentChange(page) {
      this.getAllTemplate(page)
    },
    //修改状态
    async changeValid(info) {
      const userInfo = JSON.parse(JSON.stringify(info))
      userInfo.valid = Math.abs(userInfo.valid - 1)
      const res = await this.updateTemplateData(userInfo)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('修改成功')
        this.getAllTemplate()
      }
    },
    // 删除模板
    async deleteTemplate(id) {
      if (!id) return this.$message.warning('用户id不存在')
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;',
        },
        url: this.$store.getters.path.config_template_delete,
        data: {
          id: id,
        },
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('删除成功')
        this.getAllTemplate()
      }
    },
    // 提交模板数据
    async submit() {
      if(!this.templateData.signChooseType) {
        return this.$message.error('请选择用户标签选择方式')
      }
      
      // 校验倒计时时间
      this.validateCountDown()
      if (this.countDownError) {
        return this.$message.error(this.countDownError)
      }

      // 校验限时任务
      if (this.templateData.timeLimitTask === 1) {
        if (!this.templateData.startTime || !this.templateData.endTime) {
          return this.$message.error('限时任务必须填写完整的生效时间区间')
        }
        
      }

      // 校验专属任务
      if (this.templateData.specialTask === 1) {
        if (!this.templateData.userSign || this.templateData.userSign.length === 0) {
          return this.$message.error('专属任务必须通过用户标签圈定目标用户')
        }
      }
      const type = this.templateData.taskTemplate
      const data = JSON.parse(JSON.stringify(this.templateData))
      if(data.userSign){
        data.userSign = data.userSign.join(',')
      }
      let json = null
      if (type === 1) {
        // 多节点任务
        try {
          json = JSON.stringify(this.multiNode)
        } catch (e) {
          json = JSON.stringify({
            item: [
              {
                desc: '',
                jumpPage: 0,
                proportion: 0,
                totalCount: 0,
                nodeId: '',
                periodType: null,
                triggerName: null,
                condition1: 0,
                condition1FormatType: 0,
                timeParam: '',
                param1: '',
              },
            ],
            desc: '',
            award: [],
            rewardMode: 0,
            goldDesc: '',
          })
        }
      } else if (type === 2) {
        // 周期任务
        try {
          json = JSON.stringify(this.durationNode)
        } catch (e) {
          json = JSON.stringify({
            item: [
              {
                day: 1,
                nodeId: '',
                desc: '',
                totalCount: 0,
                rate: 0,
                periodType: null,
                award: [],
                triggerName: null,
                condition1: 0,
                condition1FormatType: 0,
                rewardMode: 0,
                goldDesc: '',
                timeParam: '',
                param1: '',
              },
            ],
          })
        }
      } else if (type === 3) {
        // 组任务
        try {
          json = JSON.stringify(this.groupTask)
        } catch (e) {
          json = JSON.stringify({
            item: [
              {
                desc: '',
                icon: '',
                nodeId: '',
                totalCount: 0,
                award: [],
                jumpPage: 0,
                isIcon: 0,
                condition1: 0,
                periodType: null,
                triggerName: null,
                rewardMode: 0,
                goldDesc: '',
                timeParam: '',
                param1: '',
              },
            ],
          })
        }
      }
      data.taskJson = json
      data.channel =
        (this.templateData.channel && this.templateData.channel.length > 0)
          ? this.templateData.channel.toString()
          : ''
      data.countryCode =
        (this.templateData.countryCode && this.templateData.countryCode.length > 0)
          ? this.templateData.countryCode.toString()
          : ''
      if (this.isChannel) {
        data.channel = '-' + (this.templateData.channel ? this.templateData.channel.toString() : '')
      }
      if (this.isCountry) {
        data.countryCode = '-' + (this.templateData.countryCode ? this.templateData.countryCode.toString() : '')
      }
      if (this.isUserSign) {
        data.userSign = '-' + (this.templateData.userSign ? this.templateData.userSign.toString() : '')
      }
      const res = await this.updateTemplateData(data)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.resetForm()
        this.getAllTemplate(0)
        this.$message.success('修改成功')
      }
    },
    //修改模板数据
    async updateTemplateData(info) {
      let data = JSON.parse(JSON.stringify(info))
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_template_update,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: { data },
      })
      return res
    },
    //取消
    resetForm() {
      this.descs = []
      this.langDescs = [{ lang: null, desc: '' }]
      this.times = null
      this.countDownError = ''
      this.isTimeLimitTask = false
      this.isSpecialTask = false
      Object.keys(this.templateData).forEach(
        (key) => {
          if (key === 'signChooseType') {
            this.templateData[key] = 2
          } else if (key === 'valid') {
            this.templateData[key] = 0
          } else if (key === 'orderIndex') {
            this.templateData[key] = 0
          } else if (key === 'timeLimitTask' || key === 'specialTask') {
            this.templateData[key] = 0
          } else {
            this.templateData[key] = null
          }
        }
      )
      this.multiNode = {
        item: [
          {
            desc: '',
            jumpPage: 0,
            proportion: 0,
            totalCount: 0,
            periodType: null,
            triggerName: null,
            condition1: 0,
            condition1FormatType: 0,
            timeParam: '',
            param1: '',
          },
        ],
        descs: [],
        award: [],
        rewardMode: 0,
        goldDesc: '',
      }
      this.durationNode = {
        item: [
          {
            day: 1,
            desc: '',
            totalCount: 0,
            award: [],
            periodType: null,
            triggerName: null,
            condition1: 0,
            condition1FormatType: 0,
            rewardMode: 0,
            goldDesc: '',
            timeParam: '',
            param1: '',
          },
        ],
      }
      this.groupTask = {
        item: [
          {
            desc: '',
            icon: '',
            nodeId: '',
            totalCount: 0,
            award: [],
            jumpPage: 0,
            isIcon: 0,
            condition1: 0,
            periodType: null,
            triggerName: null,
            rewardMode: 0,
            goldDesc: '',
            timeParam: '',
            param1: '',
          },
        ],
      }
      this.templateAward = []
      this.dailogShow = false
      this.isUpdate = false
    },
    //复制或编辑
    copyOrUpdate(info, type) {
      let data = JSON.parse(JSON.stringify(info))
      if (data.startTime && data.endTime) {
        this.times = [data.startTime * 1000, data.endTime * 1000]
      }
      if (type === 2) {
        data.id = null
      } else {
        this.isUpdate = true
      }
      // 重置错误信息
      this.countDownError = ''
      data.channel = (data.channel == '' || data.channel == null) ? [] : data.channel.split(',')
      data.countryCode =
        (data.countryCode == '' || data.countryCode == null) ? [] : data.countryCode.split(',')
      if (data.countryCode.length > 0 && data.countryCode[0] && typeof data.countryCode[0] === 'string' && data.countryCode[0].charAt(0) == '-') {
        this.isCountry = true
        data.countryCode[0] = data.countryCode[0].substring(1)
      }
      if (data.channel.length > 0 && data.channel[0] && typeof data.channel[0] === 'string' && data.channel[0].charAt(0) == '-') {
        this.isChannel = true
        data.channel[0] = data.channel[0].substring(1)
      }
      if (data.userSign) {
        if(data.userSign.includes(',')){
          data.userSign = data.userSign.split(',')
        } else {
          data.userSign = [data.userSign]
        }
      }
      
      // 确保signChooseType有默认值
      if (!data.signChooseType) {
        data.signChooseType = 2
      }

      // 设置复选框状态
      this.isTimeLimitTask = data.timeLimitTask === 1
      this.isSpecialTask = data.specialTask === 1
      
      // 确保字段有默认值
      if (data.timeLimitTask === undefined || data.timeLimitTask === null) {
        data.timeLimitTask = 0
      }
      if (data.specialTask === undefined || data.specialTask === null) {
        data.specialTask = 0
      }
      
      if (data.taskType <= 0) {
        this.getAlldesc(data.taskName, data.taskTemplate)
      }

      // 根据任务类型加载对应的触发类型数据
      if (data.taskType) {
        this.triggerName(data.taskType)
      }

      // 初始化 descs 数组
      this.descs = []

      if (data.taskTemplate === 1) {
        // 多节点任务
        try {
          this.multiNode = JSON.parse(data.taskJson)
        } catch (e) {
          this.multiNode = {
            item: [
              {
                desc: '',
                jumpPage: 0,
                proportion: 0,
                totalCount: 0,
                nodeId: '',
                periodType: null,
                triggerName: null,
                condition1: 0,
                condition1FormatType: 0,
                timeParam: '',
                param1: '',
              },
            ],
            desc: '',
            award: [],
            rewardMode: 0,
            goldDesc: '',
          }
        }
        console.log(this.multiNode);
        // 确保 item 数组存在
        if (!this.multiNode.item || !Array.isArray(this.multiNode.item)) {
          this.multiNode.item = []
        }
        // 确保 descs 数组有足够的长度
        this.descs = new Array(this.multiNode.item.length).fill('')
        this.multiNode.item.forEach((items, index) => {
          this.descs[index] =
            this.triggerList.find((item) => item.value == items.triggerName)
              ?.desc || ''
          console.log("---")
          console.log(this.multiNode);
        })
        this.multiNode.rewardMode = this.multiNode.rewardMode || 0
      } else if (data.taskTemplate === 2) {
        // 周期任务
        try {
          this.durationNode = JSON.parse(data.taskJson)
        } catch (e) {
          this.durationNode = {
            item: [
              {
                day: 1,
                nodeId: '',
                desc: '',
                totalCount: 0,
                rate: 0,
                periodType: null,
                award: [],
                triggerName: null,
                condition1: 0,
                condition1FormatType: 0,
                rewardMode: 0,
                goldDesc: '',
                timeParam: '',
                param1: '',
              },
            ],
          }
        }
        // 确保 item 数组存在
        if (!this.durationNode.item || !Array.isArray(this.durationNode.item)) {
          this.durationNode.item = []
        }
        // 确保 descs 数组有足够的长度
        this.descs = new Array(this.durationNode.item.length).fill('')
        this.durationNode.item.forEach((items, index) => {
          items.rewardMode = items.rewardMode || 0
          this.descs[index] =
            this.triggerList.find((item) => item.value == items.triggerName)
              ?.desc || ''
        })
      } else if (data.taskTemplate === 3) {
        // 组任务
        try {
          this.groupTask = JSON.parse(data.taskJson)
        } catch (e) {
          this.groupTask = {
            item: [
              {
                desc: '',
                icon: '',
                nodeId: '',
                totalCount: 0,
                award: [],
                jumpPage: 0,
                isIcon: 0,
                condition1: 0,
                periodType: null,
                triggerName: null,
                rewardMode: 0,
                goldDesc: '',
                timeParam: '',
                param1: '',
              },
            ],
          }
        }
        // 确保 item 数组存在
        if (!this.groupTask.item || !Array.isArray(this.groupTask.item)) {
          this.groupTask.item = []
        }
        // 确保 descs 数组有足够的长度
        this.descs = new Array(this.groupTask.item.length).fill('')
        this.groupTask.item.forEach((items, index) => {
          items.rewardMode = items.rewardMode || 0
          this.descs[index] =
            this.triggerList.find((item) => item.value == items.triggerName)
              ?.desc || ''
        })
      }
      this.templateData = data
      this.dailogShow = true
    },
  },
}
</script>

<style scoped lang="scss">
.template-task {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}
</style>
